import { useProfileStore } from '../store/useProfileStore';
import { getById as apiGetById, patch as apiPatch, postFormData, del as apiDel } from './apiService';
import { logTrace } from './loggerService';
import { Profile } from '../types/profile';

export function setActiveProfile(profile: Profile | null) {
  useProfileStore.getState().setActiveProfile(profile);
}

export function getActiveProfile(): Profile | null {
  const profile = useProfileStore.getState().activeProfile;
  logTrace('getActiveProfile', undefined, { activeProfile: profile });
  return profile;
}

export async function getById(profileId: string, serviceKey?: string): Promise<Profile> {
  return apiGetById<Profile>('/profile', profileId, undefined, serviceKey);
}

export async function patch(profile: Partial<Profile> & { id: string }): Promise<Profile> {
  return apiPatch<Profile>(`/profile/${profile.id}`, profile);
}

export async function uploadAvatar(file: File): Promise<void> {
  const formData = new FormData();
  formData.append('file', file);
  await postFormData<void>('/profile/avatar', formData);
  await refreshActiveProfile();
}

export async function deleteAvatar(): Promise<void> {
  await apiDel<void>('/profile/avatar');
  await refreshActiveProfile();
}

async function refreshActiveProfile(): Promise<void> {
  const current = useProfileStore.getState().activeProfile;
  if (!current) return;
  const updated = await getById(current.id);
  setActiveProfile(updated);
}
